import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

class PermissionsService {
  constructor(
    private authService: AuthService,
    private router: Router) {}


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const accessToken = this.authService.getAccessToken();
    if (!accessToken) {
      return of(this.router.createUrlTree(['/login'], { queryParams: { reason: 'session-expired', returnUrl: state.url } }));
    }

    if (this.authService.isTokenExpired(accessToken)) {
      // Attempt to silently refresh so user stays authenticated.
      return this.authService.handleTokenExpiration().pipe(
        switchMap(() => this.evaluateRoleAccess(route, state)),
        catchError(() => of(this.router.createUrlTree(['/login'], { queryParams: { reason: 'session-expired', returnUrl: state.url } })))
      );
    }

    return this.evaluateRoleAccess(route, state);
  }

  private evaluateRoleAccess(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const allowedRoles = route.data['roles'] as string[] | undefined;
    const userRole = localStorage.getItem('role');

    if (!userRole) {
      return of(this.router.createUrlTree(['/login'], { queryParams: { reason: 'session-expired', returnUrl: state.url } }));
    }

    if (!allowedRoles || allowedRoles.includes(userRole)) {
      return of(true);
    }

    return of(this.router.parseUrl('/unauthorized'));
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  // NOTE: Return type supports Observable; Angular will resolve it.
  return inject(PermissionsService).canActivate(next, state) as any;
};

// export class AuthGuard implements CanActivate {
//   constructor(
//     private authService: AuthService,
//     private router: Router
//   ) {}

//   canActivate(): Observable<boolean | any> {
//     return this.authService.isLoggedIn().pipe(
//       map((isLoggedIn) => {
//         if (isLoggedIn) {
//           return true;
//         } else {
//           console.log('User not authenticated, redirecting to login...');
//           // return of(this.router.createUrlTree(['/']));n //is throwing error
//           this.router.navigate(['/']); 
//           return false;
//         }
//       }),
//       catchError(() => {
//         console.error('Error during authentication check');
//         return of(this.router.createUrlTree(['route-to-fallback-page']));
//       })
//     );
//   }
// }




// export class AuthGuard implements CanActivate {
//   constructor(private authService: AuthService, private router: Router) {}

//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): boolean {
//     if (this.authService.isLoggedIn()) {
//       console.log('User is authenticated, access granted.');
//       console.log('Access token:' + this.authService.getAccessToken());
//       return true;
//     } else {
//       console.log('User is not authenticated, redirecting to login.');
//       setTimeout(() => {
//         this.router.navigate(['/']);
//       }, 0);
//       return false;
//     }
//   }
  
// }


